export const JOBS_UNREAD_CHANGED = 'jobs-unread-changed';

export const notifyJobsUnreadChanged = (totalUnread) => {
    if (typeof window === 'undefined') {
        return;
    }
    const detail = {};
    if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
        detail.totalUnread = Math.max(0, Math.floor(totalUnread));
    }
    window.dispatchEvent(new CustomEvent(JOBS_UNREAD_CHANGED, { detail }));
};
